import z from 'zod';
import { SNIPPET_SCOPE } from './types';

// todo BUILD-3979 - finalize this schema
export const snippetVersionSchema = z.object({
  data: z.object({
    actions: z.record(z.any()),
    thresholds: z.record(z.any()),
    dataRoutes: z.record(z.any()),
  }),
  props: z.object({
    tags: z.array(z.any()),
    outcomes: z.array(z.any()),
    services: z.array(z.any()),
    publishedAttributes: z.array(z.any()),
    reasonCodeGroups: z.array(z.any()),
    lists: z.array(z.any()),
    snippets: z.array(z.any()).optional(),
  }),
  metadata: z.record(z.any()).nullable().optional(),
});

// used when inserting a snippet into local storage
export const insertSnippetPayloadSchema = z.object({
  snippet: z.object({
    version: snippetVersionSchema,
    name: z.string(),
    scope: z.enum([SNIPPET_SCOPE.GLOBAL, SNIPPET_SCOPE.LOCAL]),
  }),
  destinationWorkflow: z.object({
    workflowToken: z.string(),
    // null indicates "create V1" -- the destination workflow has no version yet,
    versionId: z.number().nullable(),
  }).strict(),
});
